import { render, staticRenderFns } from "./dataCard.vue?vue&type=template&id=65e5452a&scoped=true"
import script from "./dataCard.vue?vue&type=script&lang=js"
export * from "./dataCard.vue?vue&type=script&lang=js"
import style0 from "./dataCard.vue?vue&type=style&index=0&id=65e5452a&prod&lang=scss"
import style1 from "./dataCard.vue?vue&type=style&index=1&id=65e5452a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e5452a",
  null
  
)

export default component.exports